import cogoToast from 'cogo-toast';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { Button, Card, CardBody, Col, CustomInput, FormGroup, Input, Row, Spinner } from 'reactstrap';
import WizardInput from '../../components/auth/wizard/WizardInput';
import ButtonIcon from '../../components/common/ButtonIcon';
import DetailRow from '../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import ExampleCustomInput from '../../components/input/ExampleCustomInput';
import { urlApi } from '../../configuracion/serverConfig';
import { EnvironmentContext } from '../../context/Context';
import { formatDate } from '../../helpers/dateFormatters';
import { valorFormat } from '../../helpers/formatters';
import { desembolsoServices } from '../../services';
import ObservacionesModal from './ObservacionesModal';

const fechaCorta = s => (s ? s.substring(0, 10).split('-').reverse().join('/') : '');

const hace = dias => new Date(new Date().setDate(new Date().getDate() - dias));

const Desembolsados = () => {
    const environment = useContext(EnvironmentContext);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [buscado, setBuscado] = useState(false);
    const [editando, setEditando] = useState(null);

    const [rangoDesembolso, setRangoDesembolso] = useState([hace(30), new Date()]);
    const [rangoSolicitud, setRangoSolicitud] = useState([null, null]);
    const [cedula, setCedula] = useState('');
    const [credito, setCredito] = useState('');
    const [cliente, setCliente] = useState('');
    const [pagaduria, setPagaduria] = useState('');
    const [listPagadurias, setListPagadurias] = useState([]);

    const [desembolsoIni, desembolsoFin] = rangoDesembolso;
    const [solicitudIni, solicitudFin] = rangoSolicitud;

    useEffect(() => {
        if (!environment || !environment.pagadurias) return;
        setListPagadurias(environment.pagadurias.map(p => ({
            value: p.id,
            label: p.nombreComercial || p.razonSocial,
        })));
    }, [environment]);

    useEffect(() => {
        buscar();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const buscar = async () => {
        if (!desembolsoIni || !desembolsoFin) {
            cogoToast.warn('Por favor seleccionar el rango de fechas de desembolso',
                { position: 'bottom-left', heading: 'Campos requeridos' });
            return;
        }

        setLoading(true);
        const response = await desembolsoServices.getDesembolsados({
            ini: formatDate(desembolsoIni),
            fin: formatDate(desembolsoFin),
            solIni: solicitudIni ? formatDate(solicitudIni) : '',
            solFin: solicitudFin ? formatDate(solicitudFin) : '',
            cedula,
            credito,
            cliente,
            pagaduria,
        });
        setLoading(false);
        setBuscado(true);

        if (!response || response.error) {
            cogoToast.error(response?.msg || 'No se logró completar la operación',
                { position: 'bottom-left', heading: 'Error al cargar los desembolsos', hideAfter: 6 });
            setData([]);
            return;
        }

        setData(response.objResponse || []);
    };

    const limpiar = () => {
        setRangoDesembolso([hace(30), new Date()]);
        setRangoSolicitud([null, null]);
        setCedula('');
        setCredito('');
        setCliente('');
        setPagaduria('');
    };

    const hojaContable = (desembolso) => {
        window.open(`${urlApi}/informe/desembolso/excel/${desembolso}`, '_blank');
    };

    // El listado se queda con el texto nuevo para no repetir la consulta completa.
    const guardado = (observaciones) => {
        setData(data.map(i => (i.desembolso === editando.desembolso ? { ...i, observaciones } : i)));
        setEditando(null);
    };

    return (
        <Fragment>
            <Card className="my-3">
                <CardBody className="px-4">
                    <Row>
                        <Col lg={3} className="mx-2">
                            <DetailRow title="Fecha de desembolso">
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selectsRange
                                    locale="es"
                                    startDate={desembolsoIni}
                                    endDate={desembolsoFin}
                                    onChange={setRangoDesembolso}
                                    customInput={<ExampleCustomInput />}
                                />
                            </DetailRow>
                        </Col>
                        <Col lg={3} className="mx-2">
                            <DetailRow title="Fecha de solicitud">
                                <DatePicker
                                    dateFormat="dd/MM/yyyy"
                                    selectsRange
                                    isClearable
                                    locale="es"
                                    startDate={solicitudIni}
                                    endDate={solicitudFin}
                                    onChange={setRangoSolicitud}
                                    customInput={<ExampleCustomInput />}
                                />
                            </DetailRow>
                        </Col>
                        <Col lg={2} className="mx-2">
                            <DetailRow title="Cédula">
                                <FormGroup>
                                    <Input
                                        id="cedulaDesembolsados"
                                        value={cedula}
                                        onChange={(e) => setCedula(e.target.value)}
                                    />
                                </FormGroup>
                            </DetailRow>
                        </Col>
                        <Col lg={2} className="mx-2">
                            <DetailRow title="Nro. Crédito">
                                <FormGroup>
                                    <Input
                                        id="creditoDesembolsados"
                                        value={credito}
                                        onChange={(e) => setCredito(e.target.value)}
                                    />
                                </FormGroup>
                            </DetailRow>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={3} className="mx-2">
                            <DetailRow title="Cliente">
                                <FormGroup>
                                    <Input
                                        id="clienteDesembolsados"
                                        value={cliente}
                                        onChange={(e) => setCliente(e.target.value)}
                                    />
                                </FormGroup>
                            </DetailRow>
                        </Col>
                        <Col lg={3} className="mx-2">
                            <DetailRow title="Pagaduría">
                                <FormGroup>
                                    <WizardInput
                                        type="select"
                                        tag={CustomInput}
                                        value={pagaduria}
                                        placeholder="Todas"
                                        id="pagaduriaDesembolsados"
                                        name="pagaduria"
                                        options={listPagadurias}
                                        onChange={(e) => setPagaduria(e.target.value)}
                                        errors={[]}
                                    />
                                </FormGroup>
                            </DetailRow>
                        </Col>
                        <Col lg={4} className="mx-2">
                            <DetailRow title="-" titleClass="text-white">
                                <Button onClick={buscar} color="primary" className="mr-2" disabled={loading}>
                                    Buscar
                                </Button>
                                <Button onClick={limpiar} color="falcon-default" disabled={loading}>
                                    Limpiar
                                </Button>
                            </DetailRow>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {loading && (
                <Row className="py-4 d-flex justify-content-center">
                    <Spinner color="primary" />
                </Row>
            )}

            {!loading && buscado && !data[0] && (
                <Card className="my-3">
                    <CardBody className="px-4 text-center text-muted">
                        No hay desembolsos con esos filtros
                    </CardBody>
                </Card>
            )}

            {!loading && data[0] && (
                <Card className="my-3 table-responsive">
                    <table className="table table-dashboard table-striped table-sm fs--1 border-bottom border-200 mb-0 table-dashboard-th-nowrap">
                        <thead>
                            <tr>
                                <th>Fecha Desembolso</th>
                                <th>Fecha Solicitud</th>
                                <th>Solicitud</th>
                                <th>Crédito</th>
                                <th>Cédula</th>
                                <th>Cliente</th>
                                <th>Pagaduría</th>
                                <th style={{ textAlign: 'right' }}>Monto</th>
                                <th style={{ textAlign: 'right' }}>Neto</th>
                                <th>Observaciones hoja contable</th>
                                <th style={{ textAlign: 'center' }}>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(i => (
                                <tr key={i.desembolso}>
                                    <td>{fechaCorta(i.fecha)}</td>
                                    <td>{fechaCorta(i.fechaSolicitud)}</td>
                                    <td>{i.solicitud}</td>
                                    <td>{i.credito}</td>
                                    <td>{i.identificacion}</td>
                                    <td>{i.cliente}</td>
                                    <td>{i.pagaduria}</td>
                                    <td style={{ textAlign: 'right' }}>{valorFormat(i.monto)}</td>
                                    <td style={{ textAlign: 'right' }}>{valorFormat(i.neto)}</td>
                                    <td style={{ maxWidth: '320px' }} title={i.observaciones || ''}>
                                        {i.observaciones || <span className="text-muted">Sin observaciones</span>}
                                    </td>
                                    <td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                        <ButtonIcon
                                            onClick={() => setEditando(i)}
                                            icon="edit"
                                            transform="shrink-3 down-2"
                                            color="falcon-default"
                                            size="sm"
                                            className="mr-2"
                                            title="Editar observaciones"
                                        />
                                        <ButtonIcon
                                            onClick={() => hojaContable(i.desembolso)}
                                            icon="file-excel"
                                            transform="shrink-3 down-2"
                                            color="falcon-default"
                                            size="sm"
                                            title="Descargar hoja contable"
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>
            )}

            {editando && (
                <ObservacionesModal
                    desembolso={editando}
                    onCancel={() => setEditando(null)}
                    onSaved={guardado}
                />
            )}
        </Fragment>
    );
};

export default Desembolsados;
